/**
 * @license
 * Copyright (C) 2022 Anna Plodari
 * Software proprietario - Tutti i diritti riservati.
 * Registrato SIAE - Sezione OLAF.
 *
 * È vietato qualsiasi utilizzo non autorizzato, copia, modifica, estrazione,
 * riuso, rielaborazione, distribuzione, reverse engineering o decompilazione
 * del software, delle API, delle logiche applicative e dei dati del database.
 *
 * L'accesso al codice non costituisce concessione di licenza.
 */
/* eslint-disable react/function-component-definition */
import React from 'react';
import { useNavigate } from 'react-router';
import BuyButton from './BuyButton';
import useCompany from '../context/CompanyContext';
import PrimaryButtonSm from './PrimaryButtonSm';

interface CommonProps {
  name?: string;
  price?: string;
  promoPrice?: string;
  children: any;
  buttonText: string;
  showPromoBadge?: boolean;
  isFree?: boolean;
  isSubscriptionActive?: boolean;
  activeSubscriptionText?: string;
  hasBorder?: boolean;
}

type Props = CommonProps & (
  | {
      dataId: number;
      to?: string;
    }
  | {
      dataId?: never;
      to: `mailto:${string}`;
    }
);

const UpgradeCard: React.FC<Props> = function UpgradeCard({
  dataId,
  name,
  price,
  promoPrice,
  children,
  buttonText,
  showPromoBadge,
  isFree,
  to,
  isSubscriptionActive,
  activeSubscriptionText,
  hasBorder
}) {
  const companyContext = useCompany();
  const navigate = useNavigate();

function renderButton() {
  if (to?.match('mailto:')) {
    return (
      <div className="mt-6 flex justify-center">
        <a
          className="w-[190px] text-sm flex justify-center items-center px-6 py-2 font-primarybold rounded-full text-white bg-primary
            border-[1px] border-primary focus:outline-none disabled:bg-grey disabled:border-grey"
          href={to}>
          Acquista
        </a>
      </div>
    );
  }

  if (to) {
    return <PrimaryButtonSm text={buttonText} onClick={() => navigate(to)} />;
  }

  if (dataId === undefined) {
    return null;
  }

  return (
    <BuyButton
      dataId={dataId}
      customerEmail={companyContext.data.email || ''}
      disabled={isSubscriptionActive || isFree || !companyContext.data.email}
      text={buttonText}
    />
  );
}

  return (
    <div
      className={`shadow-card p-6 rounded-xl flex flex-col items-center max-w-[290px] bg-white ${
        hasBorder ? 'border-4 border-yellow' : null
      }`}>
      <div className="flex flex-col mt-2">
        <h5 className="font-primarybold text-black text-xs">{name}</h5>
        <div className="flex items-center">
          {promoPrice ? (
            <div className="flex flex-col">
              <h2 className=" text-primary text-[20px] font-primarybold mt-10 line-through">{price}</h2>
              <h1 className=" text-primary text-[32px] font-primarybold mb-4">{promoPrice}</h1>
            </div>
          ) : (
            <h1 className=" text-primary text-[32px] font-primarybold mt-10 mb-4">{price}</h1>
          )}
          {showPromoBadge && (
            <div className="bg-primary rounded-full py-[6px] px-2 ml-2">
              <p className="text-white text-[8px] font-primarybold">Promo primo acquisto*</p>
            </div>
          )}
        </div>
        <ul className="list-disc marker:text-primary text-sm">{children}</ul>
        <div className="mt-6 flex justify-center">
          {renderButton()}
  
        </div>
        <div className="text-sm mt-4">{activeSubscriptionText}</div>
      </div>
    </div>
  );
};

UpgradeCard.defaultProps = {
  name: '',
  price: '',
  promoPrice: '',
  showPromoBadge: false,
  isFree: false,
};

export default UpgradeCard;
